import React from "react";
import css from "./Banner.module.css";
import ErrorIcon from "@material-ui/icons/Error";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const Banner = (props) => {
  return (
    <div className={[css.Banner, props.state === "error" ? css.Error : props.state === "success" ? css.Success : props.state === "warning" ? css.Warning : ""].join(" ")}>
      {props.state === "error" ? (
        <ErrorIcon></ErrorIcon>
      ) : props.state === "success" ? (
        <CheckCircleIcon></CheckCircleIcon>
      ) : props.state === "warning" ? (
        <WarningIcon></WarningIcon>
      ) : (
        ""
      )}
      <span>{props.children}</span>
    </div>
  );
};

export default Banner;
